var MDB = window.MDB || {};;
MDB.Collections = MDB.Collections || {};

(function ($) {
    MDB.Collections.setupFormCollections = function (parent) {
        parent = $(parent);
        var formSelector = '.data-collection-form';

        parent.on('click', '.data-collection-add', function (e) {
            e.preventDefault();
            var $this = $(this);

            $.ajax({
                url: this.href,
                cache: false,
                success: function (html) { // Include the new form fields in the client-side validation.
                    html = $(html);
                    parent.find('.data-collection').append(html);

                    var form = $this.closest(formSelector);
                    form.removeData(['validator', 'unobtrusiveValidation']);
                    $.validator.unobtrusive.parse(formSelector);

                    parent.trigger('collection-added', html);
                },
                error: function (result, status, error) {
                    console.log(result);
                    console.log(status);
                    console.log(error);
                }
            });
        });

        parent.on('click', '.data-collection-remove', function () {
            var box = $(this).closest('.data-collection-box');

            box.detach();
            parent.trigger('collection-removed', box);
            box.remove();
        });
    };

})(jQuery);